import { render } from "./404.vue?vue&type=template&id=48a4197c&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=48a4197c&scoped=true&lang=css"

import exportComponent from "/Users/adamchaarawi/Desktop/dev/adams-personal-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a4197c"]])

export default __exports__